import {
  AlertTitle as MuiAlertTitle,
  AlertTitleProps,
  styled,
} from '@mui/material';

const StyledAlertTitle = styled(MuiAlertTitle)<AlertTitleProps>(() => ({
  fontSize: '18px',
  fontWeight: 500,
  lineHeight: '120%',
  marginBottom: 2,
  color: 'inherit',
}));

export function AlertTitle(props: AlertTitleProps) {
  return <StyledAlertTitle {...props} />;
}

export default AlertTitle;
